import { jsx } from "panel";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { SpinnerEl } from "common/components/spinner";
export function template() {
  const {
    fetchedDataGroups,
    selected
  } = this.state;
  const {
    t
  } = this.getContext("i18n");
  const isUsers = selected.displayName === "User";
  const tooltip = isUsers ? t("data-groups.analyze-by-users-tooltip") : t("data-groups.analyze-by-dg-tooltip");
  return /* @__PURE__ */ jsx("div", { sel: ".mp-data-group-selector-container", class: {
    "mp-data-group-selector-theme-builder": this.attr("theme") === "builder",
    "mp-data-group-selector-theme-default": !this.attr("theme"),
    "mp-data-group-selector-is-loaded": fetchedDataGroups
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-data-group-selector-label" }, t("data-groups.analyze-by")), /* @__PURE__ */ jsx("div", { sel: ".mp-data-group-selector-select-wrapper" }, !fetchedDataGroups ? /* @__PURE__ */ jsx(SpinnerEl, null) : /* @__PURE__ */ jsx(SelectEl, { attrs: {
    theme: this.attr("theme") === "builder" ? SelectTheme.Builder : SelectTheme.BuilderLight,
    sections: this.helpers.getDataGroupsList(),
    "selected-option": isUsers ? t("query-builder.dg-user") : selected.displayName,
    "menu-width": 270,
    tooltip: {
      text: "".concat(tooltip, "\n[").concat(t("common.learn-more"), "](https://help.mixpanel.com/hc/en-us/articles/360025333632)"),
      placement: "right"
    },
    "always-show-caret": true,
    icon: {
      rightIcon: "caret-down"
    }
  }, on: {
    change: this.helpers.clickDataGroupOption
  } })));
}
